import axios from 'axios'
import queryString from 'query-string'
import { getResponseData } from 'src/queries/network.utils'
import {
  PricingPlanResponse,
  PricingPlansParams,
} from 'src/queries/organizations/pricingPlans/pricingPlans.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getPricingPlans = async (
  organizationId: string,
  params?: PricingPlansParams,
): Promise<PricingPlanResponse> => {
  const qs = queryString.stringify(params ?? {})

  return getResponseData(
    axios.get<PricingPlanResponse>(
      `/saas/${organizationId}/plans${qs ? `?${qs}` : ''}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getPricingPlansLookup = async (
  bin: string,
): Promise<PricingPlanResponse> => {
  return getResponseData(
    axios.get<PricingPlanResponse>(
      `/saas/plans/lookup?bin=${bin}`,
      getRequestConfig(RequestConfig.Unauthed),
    ),
  )
}
